export function flatten<T>(arrays: readonly (readonly T[])[]) {
  return ([] as readonly T[]).concat(...arrays);
}
